/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicExternalTagReferenceDto } from './PublicExternalTagReferenceDto';
import type { PublicFilterNotificationRuleAssetScopeConditionDto } from './PublicFilterNotificationRuleAssetScopeConditionDto';

export type PublicTagFilterNotificationRuleAssetScopeConditionDto = (PublicFilterNotificationRuleAssetScopeConditionDto & {
    /**
     * Operator of the condition
     */
    operator?: PublicTagFilterNotificationRuleAssetScopeConditionDto.operator;
    /**
     * List of the tags references in the condition
     */
    tags?: Array<PublicExternalTagReferenceDto>;
} & {
    /**
     * Operator of the condition
     */
    operator: PublicTagFilterNotificationRuleAssetScopeConditionDto.operator;
    /**
     * List of the tags references in the condition
     */
    tags: Array<PublicExternalTagReferenceDto>;
});

export namespace PublicTagFilterNotificationRuleAssetScopeConditionDto {

    /**
     * Operator of the condition
     */
    export enum operator {
        IS = 'IS',
        IS_NOT = 'IS_NOT',
    }


}
